import React, { useContext, useMemo } from 'react';
import { Tag } from 'antd';
import { getMethodColor } from '../../../utils/apiRenderingUtils';
import { ThemeContext } from '../../../context/themeProvider';

const MethodBadge = ({ method }) => {
  const { mainTheme } = useContext(ThemeContext);
  const colors = useMemo(() => getMethodColor(method, mainTheme), [method, mainTheme]);
  return (
    <Tag
      className="method-badge"
      style={{
        backgroundColor: colors[1],
        color: colors[0],
        border: 'none',
      }}
    >
      {method?.toUpperCase()}
    </Tag>
  );
};

export default MethodBadge;
